// extracted by mini-css-extract-plugin
module.exports = {"content":"teantInfo_content__3Ksna","tabs":"teantInfo_tabs__3gUnY"};